import { render, staticRenderFns } from "./EditDashboardSecurityDialog.vue?vue&type=template&id=0fc61f29&scoped=true"
import script from "./EditDashboardSecurityDialog.vue?vue&type=script&lang=js"
export * from "./EditDashboardSecurityDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDashboardSecurityDialog.vue?vue&type=style&index=0&id=0fc61f29&prod&scoped=true&lang=sass"
import style1 from "./EditDashboardSecurityDialog.vue?vue&type=style&index=1&id=0fc61f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc61f29",
  null
  
)

export default component.exports